var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"videoRef",attrs:{"preload":"auto","id":"video","src":"","autoplay":""}},[_c('p',[_vm._v("Video not compatible")])])])}
var staticRenderFns = []

export { render, staticRenderFns }